import ComponentManager from '@/Management/ComponentManager';
import ToolBarLinkViewModel from '@/Components/Links/ToolBarLinkViewModel';
import GlobalConfiguration from '@/Management/GlobalConfiguration';
import * as CoreFrameDTOs from "coreframetypings/dto";
import Utilities from '@/Utility/Utilities';
import { ISelectable } from '#/DefaultViewExtensionInterfaces';

export default class EditLinkViewModel extends ToolBarLinkViewModel {

    protected dataSource: ISelectable;
    protected listView: KnockoutObservable<CoreFrameDTOs.IListViewDTO>;

    public constructor(protected params: any) {
        super($.extend(params,
            {
                ergName: 'EDIT_CONNECTED',
                tooltipErgName: 'EDIT_CONNECTED_TOOLTIP',
                imageSource: GlobalConfiguration.inlineImages.TOOLBAR_EDIT,
                locator: 'edit'
            }));

        this.setRequiredObservables();
    }

    /**
     * @override 
     */
    protected createIsEnabledObservable(): KnockoutObservable<boolean> {
        this.setRequiredObservables();

        const parameterEnabled = this.observableOrDefault(this.params.isEnabled, this.listView().showButtonEdit);
        return this.defineComputed(() => {
            if (!parameterEnabled())
                return false;

            const selected = this.dataSource.selected();
            if (selected.length !== 1) return false;

            return true;
        });
    }

    /**
     * @override 
     */
    protected createIsVisibleObservable(): KnockoutObservable<boolean> {
        if (!Utilities.isNullOrUndefined(this.params.isVisible)) {
            return this.observableOrDefault(this.params.isVisible);
        }

        this.setRequiredObservables();

        return this.createWritableComputed(() => this.listView().showButtonEdit);
    }

    /**
     * @override 
     */
    public onClick(openInNewWindow?: boolean, event?: JQuery.Event): void {
        const selected = this.dataSource.selected();
        const pdoId = this.getPdoId(selected);

        this.context.createContext(this.context, this.listView(), pdoId, null, this.getPrincipalFilterMode(this.listView()));
    }

    protected getPrincipalFilterMode(listView: CoreFrameDTOs.IListViewDTO): string {
        if (listView.includeAllPrincipals) {
            return 'PRINCIPAL_SELECTOR_ALL';
        } else if (listView.includeBasePrincipals) {
            return 'PRINCIPAL_SELECTOR_WITH_BASE';
        } else if (listView.includeSubPrincipals) {
            return 'PRINCIPAL_SELECTOR_CURRENT_AND_SUB';
        }

        return null;
    }

    /**
     * Returns the first selected pdo-id
     * @param rows
     */
    protected getPdoId(rows: any[]): string {
        return rows[0];
    }

    /**
     * Da bereits im Konstruktor der Oberklassen Methoden aufgerufen werden, die auf Member dieser Klasse zugreifen
     * muss dies in eine Methode ausgelagert werden
     */
    protected setRequiredObservables(): void {
        if (Utilities.isNullOrUndefined(this.dataSource)) {
            this.dataSource = this.paramOrDefault(this.params.dataSource, null);
        }

        if (Utilities.isNullOrUndefined(this.listView)) {
            this.listView = this.observableOrDefault(this.params.listView);
        }
    }
}

ComponentManager.setViewModel('EditLink', EditLinkViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');